<ng-container *ngIf="isLoaded" [formGroup]="editStoreForm">
  <form [formGroup]="editStoreForm" (ngSubmit)="onSubmit()">
    <nb-tabset ubsVerticalTabs>
      <nb-tab *ngFor="let fieldSet of fieldSets" [tabTitle]="fieldSet.fieldSetName">
        <ubs-ofbiz-form-group [fieldSet]="fieldSet" [ofbizForm]="ofbizForm" [fields]="fields"></ubs-ofbiz-form-group>
      </nb-tab>
    </nb-tabset>
    <!-- Main submit button outside of tabs -->
    <div class="form-actions">
      <button type="submit" nbButton status="primary" [disabled]="!editStoreForm.valid">
        Submit Complete Form
      </button>
    </div>
  </form>

</ng-container>